import * as React from 'react';
import { topModelNameTransformContext } from './context';
export function TopModelNameTransformProvider(props) {
    var transformFn = props.transformFn, children = props.children;
    return (React.createElement(topModelNameTransformContext.Provider, { value: transformFn }, children));
}
